import axios from "axios";
import { SET_ACCOUNT_INFO, REMOVE_ACCOUNT_INFO, SET_LANGUAGE } from "@/store/mutation-types";

const getAccountInfo = ({ commit }) => {
  return axios.get("account/me").then(function (response) {
    switch (response.code) {
      case 200:
        commit(SET_ACCOUNT_INFO, response.data);
        commit(SET_LANGUAGE, response.data.langByLanguage);
        break;
      case 401:
        break;
      default:
        break;
    }
  });
};

const removeAccountInfo = ({ commit }) => {
  commit(REMOVE_ACCOUNT_INFO);
};

export default {
  getAccountInfo,
  removeAccountInfo,
};
